(function (angular, schoolwork12) {

    'use strict';

    var schoolDataController= angular.module(schoolwork12.app.manageSchoolData.name);
    schoolDataController.controller(schoolwork12.app.manageSchoolData.controllers.manageSchoolData, [
         '$rootScope', '$scope', '$timeout', '$http',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.common.services.utilService,
         schoolwork12.app.fulfillment.services.getAllSchools
         ,
         function ($rootScope, $scope, $timeout, $http,
                   authentication, eventNotification, utilService, getSchools) {

            console.info("In manage school data controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Manage School Data controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
                    
                    //fetch role and schoolTypeList when user navigates directly to url
                    $scope.hasSchoolDataManagementRole  = authentication.hasSchoolDataManagementRole();
                    
              //    $scope.schoolTypeList = getAllSchools();   
                           
            });

            //Initialize global variables
            $scope.schoolDataErrorMesg = "";
            $scope.schoolDataErrorOccurred = false; 
            $rootScope.closeSuccess = false;
            $rootScope.closeWarning = false;

            $scope.isSchoolDataSearchBusy = false;
            $scope.isSearchDisabled = false; 
            $scope.schoolName = "";

            //Get list of school types                         
            var allSchoolDetails = {};
            var  allSchoolArray= [];
            var schoolTypeArray = [];
            var schoolForSearchArray=  [];
            $scope.allSchoolDetails = [];
            var defaultOptions = {
                            value: "ALL"
            };
            var getAllSchools = function () {
                $scope.isSchoolDataSpinnerActive = true;
                    getSchools.getAllSchoolsList(authentication.getCurrentUser().keycode)
                            .then(function (data) {
                                if (data) {
                                    allSchoolDetails = data;
                                    $scope.allSchoolDetails = allSchoolDetails;
                                    schoolTypeArray.push(defaultOptions.value);
                                    var keys = Object.keys(data);
                                    for (var i = 0, ii = keys.length; i < ii; i++) {
                                        schoolTypeArray.push(keys[i]);
                                        for (var j = 0, values = data[keys[i]], jj = data[keys[i]].length; j < jj; j++) {
                                            allSchoolArray.push({
                                                'name': values[j].name,
                                                'schoolId': values[j].schoolId,
                                                'abbreviation': values[j].abbreviation,
                                                'type': values[j].schoolTypeName,
                                                'currentYear':values[j].currentYear,
                                                'createDate': values[j].createDate,
                                                'createdBy': values[j].createdBy,
                                                'modifyDate': values[j].modifyDate,
                                                'modifiedBy': values[j].modifiedBy
                                            })
                                        }
                                    }
                                    $scope.schoolTypeList = schoolTypeArray;
                                    $scope.schoolTypeList.sort();
                                    if ($scope.schoolTypeList) {
                                        $scope.selectedSchoolType = $scope.schoolTypeList[0];
                                        $scope.changeSchoolValues();
                                    }
                                    console.log('Schools', allSchoolArray);
                                }
                            },function(error) {
                                console.error('Error when getting the school types and names....'.concat(angular.toJson(error)));
                                $scope.schoolDataErrorOccurred = true;
                                if (error.status == 400) {
                                    for (var j = 0; j < error.data._errors.length; j++) {
                                        $scope.schoolDataErrorMesg = $scope.schoolDataErrorMesg + error.data._errors[j] + "\n";
                                    }
                                } else if (error.status == 401 || error.status == 403) {
                                    $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                                } else {
                                    $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.internalError;
                                }
                            })['finally'](function () {
                                 $scope.isSchoolDataSpinnerActive = false;
                            });
                }

            //fetch school types when page is refreshed
            if(authentication.isAuthenticated()) { 
                  console.info("Keycode found, fetch list of school types");
                 $scope.schoolTypeList = getAllSchools();   

            } else {
                $timeout(function () {
                  console.info("Keycode not found, fetch list of school types");
                  $scope.schoolTypeList = getAllSchools();   
                }, 500);

            };

             $scope.changeSchoolValues = function () {
                        var newSchoolArray = [];
                        if (angular.equals($scope.selectedSchoolType, defaultOptions.value)) {
                            newSchoolArray = allSchoolArray;
                        }else {
                            var arrayForSchoolType = $scope.allSchoolDetails[$scope.selectedSchoolType];
                            for (var j = 0; j < arrayForSchoolType.length; j++) {
                                newSchoolArray.push({
                                    'name': arrayForSchoolType[j].name,
                                    'schoolId': arrayForSchoolType[j].schoolId,
                                    'abbreviation':arrayForSchoolType[j].abbreviation,
                                    'type': arrayForSchoolType[j].schoolTypeName,
                                    'currentYear': arrayForSchoolType[j].currentYear,
                                    'createDate': arrayForSchoolType[j].createDate,
                                    'createdBy': arrayForSchoolType[j].createdBy,
                                    'modifyDate': arrayForSchoolType[j].modifyDate,
                                    'modifiedBy': arrayForSchoolType[j].modifiedBy
                                });
                            }  
                        }
                        schoolForSearchArray = newSchoolArray;
                    ;
             };
            
            $scope.schoolDataModal = function(grid, row, size){
                var currentPageNumber = $scope.gridApi.pagination.getPage();
                $scope.schoolDataResultsGridObject = {
                    searchResults : $scope.gridOptions.data,
                    currentPage : $scope.paginationChanged ? $scope.currentPageSelection : currentPageNumber,
                    gridPageSize: $scope.paginationChanged ? $scope.currentPageSize : 25 ,
                    grid: $scope.gridApi,
                    row : row
                }

            }

            $scope.gridOptions = {
                rowHeight: 50,
                paginationPageSizes : [ 25, 50, 75 ],
                paginationPageSize : 25,
                enableRowSelection : true
            };            

            $scope.gridOptions.onRegisterApi = function(gridApi) {

                $scope.gridApi = gridApi;
               
                $scope.resizeGrid = {
                    'width' : 'auto',
                    'margin-left': '300px'
                };

                $scope.paginationChanged = false;
                $scope.currentPageSize = 25;
                var pageNumber, pageSize;
                $scope.gridApi.pagination.on.paginationChanged($scope, function (pageNumber, pageSize){  
                    console.log("paginationChanged")         ;    
                    console.log(""+pageNumber+"-"+pageSize);              
                    $scope.paginationChanged = true;
                    $scope.currentPageSelection = pageNumber;
                    $scope.currentPageSize = pageSize;
                }); 
            };

            $scope.gridOptions.columnDefs = [
                { field: 'schoolId', displayName: 'School ID', width: '20%', sort: {direction: 'asc'}},
                { field: 'name', displayName: 'School Name',
                 cellTemplate: '<div title="School Data details" class="ui-grid-cell-contents schoolDataEdit" >' + 
                 '<span ui-sref="schoolData.school({name: row.entity.name})" ng-click="grid.appScope.schoolDataModal(grid, row, size)">{{row.entity[col.field]}}</span>' + 
                 '</div>'
                },
                { field: 'abbreviation', displayName: 'Abbreviation',  width: '30%'},
            ];

            //Get schools from selected type
            $scope.getSchoolsList = function(){
                $scope.isSchoolDataSearchBusy = true;
                $scope.schoolDataErrorMesg = "";
                var newSchoolArray = [];
                $scope.gridOptions.data = newSchoolArray;
                if($scope.schoolName && $scope.schoolName.length>0 ){
                    for (var j = 0; j < schoolForSearchArray.length; j++) {
                        if(schoolForSearchArray[j].name.toLowerCase().indexOf($scope.schoolName.toLowerCase()) >= 0){
                            newSchoolArray.push(schoolForSearchArray[j]);
                        }
                    }    
                }else newSchoolArray = schoolForSearchArray;
                
                if (newSchoolArray.length > 0) {
                    console.info("Viewing schools grid");  
                    $scope.schoolDataErrorOccurred = false;
                    $scope.schoolDataErrorMesg = " ";   
                    $scope.displaySchoolDataGrid = true;
                    $scope.gridOptions.data = newSchoolArray;

                } else {
                    $scope.schoolDataErrorOccurred = true;
                    $scope.schoolDataErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                };
                $scope.isSchoolDataSearchBusy = false;
            }
     
    }]);
}(angular, schoolwork12));
